export default "__VITE_ASSET__168e1544__"